import type { SVGProps } from 'react';

interface TrashIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function TrashIcon({ className, ...props }: TrashIconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M1.75 3.5H12.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 3.5V2.625C5.25 2.14175 5.63175 1.75 6.125 1.75H7.875C8.36825 1.75 8.75 2.14175 8.75 2.625V3.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9375 3.5L10.5 11.375C10.475 11.8583 10.0917 12.25 9.625 12.25H4.375C3.90833 12.25 3.525 11.8583 3.5 11.375L3.0625 3.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
